const PointTransferTypes = {
    TRANSFER : "TRANSFER",
    DONATE : "DONATE",
    
}

export { PointTransferTypes }